import { useTranslation } from 'react-i18next';
import { ButtonLink, Form } from '@anytag/shared-atoms';
import { BasicFilterDefaultProps } from '../../schemaTypes';
import { InfluencerTabField, KeywordField, CountriesField } from '../../shared';

export const BasicFilter = ({ onSubmit, isEngagementPage }: BasicFilterDefaultProps) => {
  const { t } = useTranslation();

  return (
    <Form.Fields>
      <InfluencerTabField isEngagementPage={isEngagementPage} onSubmit={onSubmit} />
      <KeywordField onSubmit={onSubmit} placeholder={t<string>('Search.InfluencerPackageFilter')} />
      <CountriesField onSubmit={onSubmit} />
      <Form.Field className="flex-none">
        <ButtonLink
          to="/package/add"
          variant="outline"
          className="min-w-38 uppercase"
          title={`+ ${t('Button.Add Package')}`}
        />
      </Form.Field>
    </Form.Fields>
  );
};
